import * as React from 'react';
import { useSelector } from 'react-redux';
import { SeoMortgageLink as SeoMortgageLinkComponent } from '../../components/SeoMortgageLink';
import { promosSeoPageUrlSelector } from '../../selectors/seoPages';
import { trackClickPromosSeoLink } from '../PromosSection/tracking';

export const SeoPromosLink = () => {
  const url = useSelector(promosSeoPageUrlSelector);

  const onClick = React.useCallback(() => {
    trackClickPromosSeoLink();
  }, []);

  return <SeoMortgageLinkComponent url={url} onClick={onClick} title="Акции и скидки" testId="seo_promos_link" />;
};
